import { Pipe, PipeTransform, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { OptimizedI18nService } from '../services/optimized-i18n.service';
import { Subscription } from 'rxjs';

@Pipe({
  name: 'optimizedI18n',
  pure: false // Para que se actualice cuando cambie el idioma
})
export class OptimizedI18nPipe implements PipeTransform, OnDestroy {
  private subscription: Subscription = new Subscription();
  private lastKey: string = '';
  private lastParams: { [key: string]: string | number } | undefined;
  private lastValue: string = '';
  private lastLanguage: string = '';

  constructor(
    private i18nService: OptimizedI18nService,
    private cdr: ChangeDetectorRef
  ) {
    // Suscribirse a cambios de idioma para forzar actualización
    this.subscription.add(
      this.i18nService.getCurrentLanguage().subscribe((lang) => {
        this.lastLanguage = lang;
        this.cdr.markForCheck();
      })
    );
    
    // También suscribirse a cambios de traducciones
    this.subscription.add(
      this.i18nService.translations$.subscribe(() => {
        this.cdr.markForCheck();
      })
    );
  }

  transform(key: string, params?: { [key: string]: string | number }): string {
    const currentLang = this.i18nService.getCurrentLanguageValue();
    
    // Siempre recalcular para cambios instantáneos
    this.lastKey = key;
    this.lastParams = params;
    this.lastLanguage = currentLang;
    this.lastValue = this.i18nService.translate(key, params);
    
    return this.lastValue;
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
